"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
exports.view = view;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ReactRedux = __importStar(require("react-redux"));
const GraphQLRequest = __importStar(require("@genesys/graphql-request"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Loaders = __importStar(require("@genesys/client-core/lib/loaders"));
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const rotor_product_validation_state_1 = require("./rotor-product-validation-state");
const Exporter = __importStar(require("@genesys/client-core/lib/exporter"));
const Root = styled_components_1.default.div `
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;
const SettingsContainer = styled_components_1.default.div `
  flex: 0 0 auto;
  padding: 20px;
  h3 {
    padding: 5px 0;
  }
  ul {
    li {
      padding: 5px;
    }
  }

  button {
    margin: 20px 0;
  }
`;
const ResultContainer = styled_components_1.default.div `
  flex: 1 0 auto;
  button {
    margin: 20px 0;
  }
  textarea {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background: #ebebeb;
    box-sizing: border-box;
    resize: none;
  }
`;
const queryProducts = (0, graphql_tag_1.default) `
  query RotorProductValidationAllProductIds {
    product {
      getRotorProductIds
    }
  }
`;
const getRotorProductValidationErrorsQuery = (0, graphql_tag_1.default) `
  query RotorProductValidationErrors($input: RotorProductValidationInputType!) {
    product {
      getRotorProductValidationErrors(input: $input)
    }
  }
`;
const pleaseSelect = "please-select";
function view({ state, dispatch }) {
    return (React.createElement(GraphQLQuery.QueryProductSimple, { query: queryProducts, variables: {} }, productData => {
        const rotorProductIds = productData.product.getRotorProductIds
            .concat()
            .sort((a, b) => a.localeCompare(b));
        return (React.createElement(Contexts.clientConfigContext.Consumer, null, config => (React.createElement(Loaders.PleaseWaitOverlayLoaderIndicator, { active: state.loading },
            React.createElement(Loaders.ProgressOverlayLoaderIndicator, { active: state.validationProgress.inProgress, message: state.validationProgress.message, current: state.validationProgress.current, max: state.validationProgress.max },
                React.createElement(Root, null,
                    React.createElement(SettingsContainer, null,
                        React.createElement(Elements.ExpanderWithArrow, { isCollapsed: state.filterCollapsed, onToggle: () => {
                                dispatch(rotor_product_validation_state_1.Action.RotorProductValidationToggleFilter());
                            }, text: "Filter" }),
                        !state.filterCollapsed && (React.createElement(React.Fragment, null,
                            React.createElement("h3", null,
                                React.createElement("p", null, "Hi! This is an experimental tool for validating a product. This is of course not a full check as new features are added every day, but it can be good for finding holes in the data at least. Have fun!"),
                                React.createElement("p", null, "NOTE 1 !!! It is highly recommended to follow the order below. !!!"),
                                React.createElement("p", null, "NOTE 2 !!! After fixing the data in Maintenance/Promaster, Reset cache to validate your freshly corrected data. !!!")),
                            React.createElement("ul", null,
                                React.createElement("li", null,
                                    React.createElement(React.Fragment, null,
                                        React.createElement(Elements.SelectBox, { value: state.settings.productId || pleaseSelect, onChange: e => {
                                                dispatch(rotor_product_validation_state_1.Action.RotorProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { productId: e.target.value })));
                                            } },
                                            React.createElement("option", { value: pleaseSelect }, "Please select"),
                                            rotorProductIds.map(p => (React.createElement("option", { key: p, value: p }, p))))))),
                            React.createElement(Elements.StandardButton, { disabled: state.settings.productId === undefined ||
                                    state.settings.productId === pleaseSelect, onClick: async () => {
                                    dispatch(rotor_product_validation_state_1.Action.RotorProductValidationSetValidationProgress(true, "Initialize", 0, 0));
                                    dispatch(rotor_product_validation_state_1.Action.RotorProductValidationSetResult([]));
                                    const productId = state.settings.productId;
                                    const numberOfSteps = 1;
                                    const messages = [];
                                    let current = 1;
                                    current++;
                                    dispatch(rotor_product_validation_state_1.Action.RotorProductValidationSetValidationProgress(true, "Validation", current, numberOfSteps));
                                    const rotorProductValidationErrors = await getRotorProductValidationErrors(productId, state.settings.errorsOnly, config.graphqlEndpoint, config.authorization);
                                    messages.push(...rotorProductValidationErrors.product
                                        .getRotorProductValidationErrors);
                                    current++;
                                    dispatch(rotor_product_validation_state_1.Action.RotorProductValidationSetValidationProgress(true, "General errors", current, numberOfSteps));
                                    dispatch(rotor_product_validation_state_1.Action.RotorProductValidationSetResult(messages));
                                    dispatch(rotor_product_validation_state_1.Action.RotorProductValidationSetValidationProgress(false, "", 0, 0));
                                    dispatch(rotor_product_validation_state_1.Action.RotorProductValidationHideFilter());
                                } }, "Validate"),
                            React.createElement("label", null,
                                "\u00A0Show only errors",
                                React.createElement("input", { type: "checkbox", checked: state.settings.errorsOnly, onChange: () => {
                                        dispatch(rotor_product_validation_state_1.Action.RotorProductValidationSetSettings(Object.assign(Object.assign({}, state.settings), { errorsOnly: !state.settings.errorsOnly })));
                                    } }))))),
                    React.createElement(ResultContainer, null,
                        React.createElement(Exporter.XlsxSingleSheetExport, { data: getDataAsTable(state.messages), filename: state.settings.productId +
                                +" - Product validation results" }, onClick => (React.createElement(Elements.StandardButton, { disabled: state.messages.length === 0, onClick: onClick }, "Export"))),
                        state.messages.length > 1000 ? (React.createElement(React.Fragment, null,
                            " ",
                            "Displaying only 1000 rows. Use excel export for the rest.")) : (React.createElement(React.Fragment, null)),
                        React.createElement("textarea", { readOnly: true, value: state.messages
                                .slice(0, Math.min(1000, state.messages.length))
                                .join("\n") }))))))));
    }));
}
function getDataAsTable(messages) {
    return messages.map(v => {
        const row = [];
        row.push(v);
        return row;
    });
}
function getRotorProductValidationErrors(productId, errorsOnly, graphqlEndpoint, authorization) {
    return GraphQLRequest.request(getRotorProductValidationErrorsQuery, {
        input: {
            rotorProductId: productId,
            errorsOnly: errorsOnly
        }
    }, true, graphqlEndpoint, authorization);
}
exports.View = ReactRedux.connect((state) => ({ state: state.ui.rotorProductValidation }))(view);
//# sourceMappingURL=rotor-product-validation-view.js.map